// extracted by mini-css-extract-plugin
module.exports = {"footer":"LandingFooter_footer__2yEi_","connectUs":"LandingFooter_connectUs__1VLl_","select":"LandingFooter_select__3POTJ","copyright":"LandingFooter_copyright__14a6q"};